import { createHashHistory } from 'history';

const hashHistory = createHashHistory();

export default hashHistory;
